import api from '../api/axios';

export interface Department {
  id?: number;
  name: string;
  code: string;
  description?: string;
  manager?: number;
  parentDepartment?: number;
  location?: string;
  email?: string;
  phoneNumber?: string;
  budget?: number;
  isActive?: boolean;
}

class DepartmentService {
  async getDepartments(params?: any) {
    const response = await api.get('/departments', { params });
    return response;
  }

  async getDepartment(id: number) {
    const response = await api.get(`/departments/${id}`);
    return response;
  }

  async createDepartment(data: Department) {
    const response = await api.post('/departments', { data });
    return response;
  }

  async updateDepartment(id: number, data: Partial<Department>) {
    const response = await api.put(`/departments/${id}`, { data });
    return response;
  }

  async deleteDepartment(id: number) {
    const response = await api.delete(`/departments/${id}`);
    return response;
  }
}

const departmentServiceInstance = new DepartmentService();
export default departmentServiceInstance;

